import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Existing: {
    id: 'label_existing',
    defaultMessage: 'Existing',
  },
  CustomLocation: {
    id: 'label_custom_location',
    defaultMessage: 'Custom location',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  TabName: {
    id: 'label_tab_name',
    defaultMessage: 'Tab name',
  },
  Department: {
    id: 'label_department',
    defaultMessage: 'Department',
  },
  Street: {
    id: 'label_street',
    defaultMessage: 'Street',
  },
  ZipCity: {
    id: 'label_zip_city',
    defaultMessage: 'Zip City',
  },
  Email: {
    id: 'label_email',
    defaultMessage: 'Email',
  },
  Phone: {
    id: 'label_phone',
    defaultMessage: 'Phone',
  },
  Latitude: {
    id: 'label_latitude',
    defaultMessage: 'Latitude',
  },
  Longitude: {
    id: 'label_longitude',
    defaultMessage: 'Longitude',
  },
  ButtonLink: {
    id: 'label_button_link',
    defaultMessage: 'Button link',
  },
  Locations: {
    id: 'label_locations',
    defaultMessage: 'Locations',
  },
});

export const LocationSchema = (props) => ({
  addMessage: props.intl.formatMessage(messages.AddItem),
  conditions: {
    title: {
      custom: true,
    },
    tab_name: {
      custom: true,
    },
    department: {
      custom: true,
    },
    street: {
      custom: true,
    },
    zip_city: {
      custom: true,
    },
    email: {
      custom: true,
    },
    phone: {
      custom: true,
    },
    latitude: {
      custom: true,
    },
    longitude: {
      custom: true,
    },
    buttonlink: {
      custom: true,
    },
  },
  fieldsets: [
    {
      fields: [
        'location',
        'custom',
        'title',
        'tab_name',
        'department',
        'street',
        'zip_city',
        'email',
        'phone',
        'latitude',
        'longitude',
        'buttonlink',
      ],
      id: 'default',
      title: '',
    },
  ],
  properties: {
    location: {
      title: props.intl.formatMessage(messages.Existing),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            mode: 'single',
            return: 'single',
            selectableTypes: ['Location'],
          },
        },
      },
    },
    custom: {
      title: props.intl.formatMessage(messages.CustomLocation),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    title: {
      title: props.intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    tab_name: {
      title: props.intl.formatMessage(messages.TabName),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    department: {
      title: props.intl.formatMessage(messages.Department),
      widgetOptions: {
        frontendOptions: {
          widget: 'textarea',
        },
      },
    },
    street: {
      title: props.intl.formatMessage(messages.Street),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    zip_city: {
      title: props.intl.formatMessage(messages.ZipCity),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    email: {
      title: props.intl.formatMessage(messages.Email),
      widgetOptions: {
        frontendOptions: {
          widget: 'email',
        },
      },
    },
    phone: {
      title: props.intl.formatMessage(messages.Phone),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    latitude: {
      title: props.intl.formatMessage(messages.Latitude),
      widgetOptions: {
        frontendOptions: {
          widget: 'number',
        },
      },
    },
    longitude: {
      title: props.intl.formatMessage(messages.Longitude),
      widgetOptions: {
        frontendOptions: {
          widget: 'number',
        },
      },
    },
    buttonlink: {
      title: props.intl.formatMessage(messages.ButtonLink),
      widgetOptions: {
        frontendOptions: {
          widget: 'url',
        },
      },
    },
  },
  required: [],
  title: props.intl.formatMessage(messages.Locations),
});
